import { FinalPriceUpdateBehavior } from "@/enums/document-type-enum";

export type FinalPriceUpdateChoice =
  | FinalPriceUpdateBehavior.RecalculateDiscount
  | FinalPriceUpdateBehavior.RecalculateUnitPrice;

const normalizeBehavior = (
  value?: string | boolean
): string | undefined => {
  if (typeof value !== "string" || !value.trim()) {
    return undefined;
  }

  return value.replace(/\s/g, "").toLowerCase();
};

export const isAskUserFinalPriceUpdateBehavior = (
  behavior?: string | boolean
): boolean => {
  return (
    normalizeBehavior(behavior) ===
    FinalPriceUpdateBehavior.AskUser.toLowerCase()
  );
};

export const resolveFinalPriceUpdateChoice = ({
  behavior,
  hideDiscountColumn,
}: {
  behavior?: string | boolean;
  hideDiscountColumn: boolean;
}): FinalPriceUpdateChoice | "ask" | undefined => {
  if (!isAskUserFinalPriceUpdateBehavior(behavior)) {
    return undefined;
  }

  if (hideDiscountColumn) {
    return FinalPriceUpdateBehavior.RecalculateUnitPrice;
  }

  return "ask";
};
